module.exports = __webpack_public_path__ + "img/battery.5145909e.svg";